module.exports = __webpack_public_path__ + "img/clapping.895e8b4e.png";